import axios from 'axios'
import { message, notification } from 'ant-design-vue'
// import store from '@/store'
// import storage from 'store'
// import notification from 'ant-design-vue/es/notification'
// import message from 'ant-design-vue/es/message'
import { VueAxios } from './axios'
// import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 6000, // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    if (error.response.status === 500) {
      notification.error({
        message: 'Forbidden',
        description: data.message,
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use((config) => {
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  const { data } = response
  if (data.success === false) {
    message.warning(data.message)
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  },
}

export default request

export { installer as VueAxios, request as axios }
